import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import classes from "./Login.module.css";
import logo from "../../Assest/logo.png";
import hospital from "../../Assest/logo.jpeg";

import {
  FiMail,
  FiLock,
  FiEye,
  FiEyeOff,
  FiShield,
  FiTrendingUp,
  FiUsers,
  FiArrowLeft,
} from "react-icons/fi";

const Login = () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);
    if (!email || !password) {
      setError("Please fill in all fields");
      setIsLoading(false);
      return;
    }

   
    setTimeout(() => {

      if (email && password) {
        setIsLoading(false);
        // Store user session
        localStorage.setItem("isAuthenticated", "true");
        localStorage.setItem("userEmail", email);
        // Navigate to dashboard
        navigate("/dashboard");
      } else {
        setError("Invalid email or password");
        setIsLoading(false);
      }
    }, 1000);
  };

  const handleForgotPassword = () => {
    navigate("/forgot-password");
  };

  return (
    <div className={classes.container}>
      <div className={classes.left}>
        <img src={hospital} alt="Hospital" className={classes.bgImage} />
        <div className={classes.overlay}></div>

        <div className={classes.leftContent}>
          <div className={classes.logoRow}>
            <img src={logo} alt="logo" className={classes.logo} />
            <div>
              <h2>City Care Hospital</h2>
              <span>Hospital Management System</span>
            </div>
          </div>

          <div className={classes.hero}>
            <h1>
              Better Care.
              <br />
              Smarter Management.
            </h1>
            <div className={classes.line}></div>
            <p>
              Streamline your hospital operations and
              deliver exceptional patient care with our
              comprehensive management system.
            </p>
          </div>

          <div className={classes.featureCard}>
            <div className={classes.feature}>
              <div className={classes.icon}>
                <FiShield />
              </div>
              <div>
                <h4>Secure & Compliant</h4>
                <p>HIPAA compliant with enterprise-level security</p>
              </div>
            </div>

            <div className={classes.feature}>
              <div className={classes.icon}>
                <FiTrendingUp />
              </div>
              <div>
                <h4>Real-time Analytics</h4>
                <p>Make informed decisions with live reporting</p>
              </div>
            </div>

            <div className={classes.feature}>
              <div className={classes.icon}>
                <FiUsers />
              </div>
              <div>
                <h4>Patient Centered</h4>
                <p>Enhance patient experience and quality care</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={classes.right}>
        <div className={classes.loginCard}>
          <h1>Welcome Back</h1>
          <p className={classes.subtitle}>Sign in to your account to continue</p>

          {error && <div className={classes.errorMessage}>{error}</div>}

          <form onSubmit={handleLogin}>
            <div className={classes.formGroup}>
              <label>Email Address</label>
              <div className={classes.input}>
                <FiMail className={classes.inputIcon} />
                <input
                  type="email"
                  placeholder="Enter your email address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
            </div>

            <div className={classes.formGroup}>
              <label>Password</label>
              <div className={classes.input}>
                <FiLock className={classes.inputIcon} />
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <span
                  className={classes.eye}
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <FiEyeOff /> : <FiEye />}
                </span>
              </div>
            </div>

            <div className={classes.row}>
              <label className={classes.remember}>
                <input
                  type="checkbox"
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                />
                Remember me
              </label>
              <button
                type="button"
                className={classes.forgotLink}
                onClick={handleForgotPassword}
              >
                Forgot Password?
              </button>
            </div>

            <button
              type="submit"
              className={classes.loginBtn}
              disabled={isLoading}
            >
              {isLoading ? "Signing in..." : "Sign In"}
            </button>
          </form>

          <div className={classes.divider}>
            <span></span>
            <p>or</p>
            <span></span>
          </div>

          <button className={classes.googleBtn}>
            <img
              src="https://www.svgrepo.com/show/475656/google-color.svg"
              alt="Google"
            />
            Sign in with Google
          </button>

          <div className={classes.contact}>
            Don't have an account?
            <span> Contact Administrator</span>
          </div>
        </div>

        <p className={classes.footer}>
          © 2024 City Care Hospital. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default Login;